module.exports = __webpack_public_path__ + "static/media/hero.b294932a.gif";